import { DynamicFilterField } from "@edgetier/dynamic-filter";
import { ITagGroup, TagGroupType } from "@edgetier/watchtower-types";
import { faTag } from "@fortawesome/pro-solid-svg-icons";
import { IExploreFilters } from "components-for/filters/explore-filters/explore-filters.types";
import SelectTag from "components-for/filters/select-tag";
import { FILTER_TAGS_ENABLED } from "constants/feature-flags";
import { FilterGroups, FilterGroupsOrder } from "constants/filters";
import { useFormikContext } from "formik";
import { useInteractionsMessageQueryParameters } from "hooks-for/interaction-messages/use-interactions-messages-query-parameters";

/**
 * A hook that requests tags and tag groups, filters by the explore filters selected and returns dynamic filter fields
 * for each tag.
 * @param tagGroups The tag groups that the user will be able to filter by.
 * @returns An object with the tag fields and the tagGroups.
 */
export const useSelectTagFields = (tagGroups: ITagGroup[]) => {
    const { values } = useFormikContext<IExploreFilters>();
    const { interactionEndDateTime, interactionStartDateTime } = useInteractionsMessageQueryParameters({
        additionalParameters: values ?? {},
        prefixValue: "interaction",
        excludedParameters: ["interactionType", "webSearchSyntax", "tagId"],
    });

    const tagFields = tagGroups.map(({ tagGroup, tagGroupId, tagGroupType }) => (
        <DynamicFilterField
            key={tagGroupId}
            name={`tagGroups.${tagGroupId}`}
            label={tagGroup}
            icon={faTag}
            group={tagGroupType === TagGroupType.Agent ? FilterGroups.AgentGroups : FilterGroups.TagGroups}
            groupOrder={
                FilterGroupsOrder[
                    tagGroupType === TagGroupType.Agent ? FilterGroups.AgentGroups : FilterGroups.TagGroups
                ]
            }
        >
            <SelectTag
                description={tagGroup}
                name={`tagGroups.${tagGroupId}`}
                parameters={FILTER_TAGS_ENABLED ? { interactionEndDateTime, interactionStartDateTime } : undefined}
                placeholder={`Select ${tagGroup}…`}
                tagGroupId={tagGroupId}
            />
        </DynamicFilterField>
    ));

    return { tagFields, tagGroups };
};
